export default __webpack_public_path__ + "static/media/im-bc.be38e335.svg";